/**
 * M7 S32: Your records (spec §2.4), in the Column Nine manifest table form: the player's own sales, kills, meter
 * readings, the corporation's share, stations handed to Tethys, and the generated logs (the named pilot's message).
 * No totals, no counters.
 */
import type { ReactNode } from 'react'
import type { LogsConfig } from './models/config'
import type { RecordsView } from './models/records'
import { EntryList, Table } from './LogView'

export interface YourRecordsProps {
  records: RecordsView
  config: LogsConfig
  focusedRow: number
  onOpen: (index: number) => void
}

export function YourRecords(p: YourRecordsProps): ReactNode {
  const r = p.records
  if (r.empty) return <p className="sui-empty">{p.config.empty.records}</p>
  return (
    <div data-testid="logs-records">
      {r.tables.map((t) => (
        <section key={t.id} className="lg-section" data-testid={`logs-records-${t.id}`}>
          <h3 className="lg-section__title">{t.title}</h3>
          <Table table={t} />
          {t.caption === null ? null : <p className="lg-caption">{t.caption}</p>}
        </section>
      ))}
      {r.lines.map((l) => (
        <section key={l.title} className="lg-section" data-testid="logs-records-line">
          <h3 className="lg-section__title">{l.title}</h3>
          <p className="lg-log__body">{l.text}</p>
        </section>
      ))}
      {r.logs.length === 0 ? null : <EntryList entries={r.logs} config={p.config} focusedRow={p.focusedRow} onOpen={p.onOpen} />}
    </div>
  )
}
